import * as React from "react";
import { Auth } from "aws-amplify";
import logoSVG from "../../assets/forward_logo.svg";
import { Form, Icon, Input, Button, Col, Row, message, Spin } from "antd";
import { FormComponentProps } from "antd/lib/form";
import styled from "styled-components";

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: #ffffff;
  padding-top: 15%;
`;

const StyledInput = styled(Input)`
  ${props => (props.prefix ? "input {" : "")}
  height: 40px !important;
  background-color: #f2f2f2 !important;
  border: none !important;
  font-size: 14px !important;
  line-height: 32px !important;
  color: #386ee8 !important;
  font-weight: 300 !important;
  &::placeholder {
    color: #386ee8 !important;
    font-weight: 300 !important;
  }
  ${props => (props.prefix ? "}" : "")}
`;

const InvisibleButton = styled.button`
  border: none !important;
  outline: none !important;
  padding: 1px;
  background-color: transparent;
  cursor: pointer;
  color: #061a32;
  &:hover {
    color: #386ee8;
  }
`;

type Props = FormComponentProps & {
  authState: string;
  onStateChange: (newState: string, payload?: object) => void;
};

type State = {
  isLoading: boolean;
  errors: Array<any>;
};

class ForwardSignIn extends React.Component<Props, State> {
  readonly _validAuthStates = ["signIn", "signedOut", "signedUp"];
  readonly state: State = {
    isLoading: false,
    errors: []
  };

  handleSubmit = (e: React.FormEvent<any>) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        this.setState({ errors: [err] });
      } else {
        this.setState({ errors: [] });
        this.signIn(values.username, values.password);
      }
    });
  };

  render() {
    if (this.props.authState !== "signIn") return null;
    const { getFieldDecorator } = this.props.form;
    return (
      <Wrapper>
        <Row type="flex" justify="center">
          <Col span={6} xs={18} sm={14} md={6}>
            <Row>
              <Col span={24} style={{ textAlign: "center" }}>
                <img
                  src={logoSVG}
                  style={{ marginBottom: "40px", width: "80%" }}
                  alt="logo"
                />
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Item>
                    {getFieldDecorator("username", {
                      rules: [
                        {
                          required: true,
                          message: "Bitte geben Sie Ihre E-Mail-Adresse ein."
                        }
                      ],
                      // disallow spaces
                      normalize: value => (value || "").replace(/\s/g, "")
                    })(
                      <StyledInput
                        prefix={
                          <Icon type="user" style={{ color: "#386ee8" }} />
                        }
                        placeholder="E-Mail"
                      />
                    )}
                  </Form.Item>
                  <Form.Item>
                    {getFieldDecorator("password", {
                      rules: [
                        {
                          required: true,
                          message: "Bitte geben Sie Ihr Passwort ein."
                        }
                      ],
                      // disallow spaces
                      normalize: value => (value || "").replace(/\s/g, "")
                    })(
                      <StyledInput
                        prefix={
                          <Icon type="lock" style={{ color: "#386ee8" }} />
                        }
                        type="password"
                        placeholder="Passwort"
                      />
                    )}
                  </Form.Item>
                  <Form.Item>
                    <Row>
                      <Col span={24}>
                        <Spin
                          indicator={<Icon type="loading" spin />}
                          spinning={this.state.isLoading}
                        >
                          <Button
                            type="primary"
                            htmlType="submit"
                            style={{
                              width: "100%",
                              borderRadius: 0,
                              boxShadow: "0 3px 6px 0 rgba(0, 0, 0, 0.16)",
                              height: 36
                            }}
                          >
                            Log In
                          </Button>
                        </Spin>
                      </Col>
                    </Row>
                    <Row>
                      <Col span={24} style={{ textAlign: "center" }}>
                        <InvisibleButton onClick={this.forgotPassword}>
                          Passwort vergessen?
                        </InvisibleButton>
                      </Col>
                    </Row>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      </Wrapper>
    );
  }
  signIn = async (username: string, password: string) => {
    this.setState({ isLoading: true });
    try {
      const user = await Auth.signIn(username, password);
      this.props.onStateChange("signedIn", user);
      this.setState({ isLoading: false });
    } catch (error) {
      message.error(error.message);
      this.setState({ isLoading: false });
    }
  };
  forgotPassword = () => {
    this.props.onStateChange("forgotPassword");
  };
}

const WrappedForwardSignIn = Form.create<Props>({ name: "normal_login" })(
  ForwardSignIn
);

export default WrappedForwardSignIn;
